import { type Lesson } from "@core/grades/types";
import { trans, plainTrans } from "@mongez/localization";
import { LessonsCarousel } from "./LessonsCarousel";

type PopularLessonsSectionProps = {
  lessons: Lesson[];
  className?: string;
};

export function PopularLessonsSection({
  lessons,
  className,
}: PopularLessonsSectionProps) {
  if (!lessons?.length) return null;

  return (
    <LessonsCarousel
      title={plainTrans("home.popularLessons")}
      lessons={lessons}
      className={className}
      icon={<span className="text-xl">🔥</span>}
    />
  );
}
